import details from './details'

export default {
  title: 'The NextDev Database Center',
  slug: 'tnd-database',
  createdAt: '1610448539809',
  description:
    'Platform yang bertujuan untuk menjadi sumber referensi utama untuk ekosistem startup digital dan social impact.',
  details,
  tint: '#660248'
}
